export default {
  MAX_DAYS_BACK_FOR_CONVERSATIONS: 660,
  /** Debounce window (ms) for skipping duplicate getMessages refetches after user sends a message. Used by AddMessage, ConversationList, and MessageList. */
  MESSAGE_JUST_SENT_DEBOUNCE_MS: 2000,
};
